import { observer } from "mobx-react";
import { h } from "preact";
import { useState } from "preact/hooks";
import { t, translate } from "../../I18n";
import FulfillmentMethodSwitcher from "./FulfillmentMethodSwitcher";
import FulfillmentAddressModal from "./FulfillmentAddressModal";
import FulfillmentTimeModal from "./FulfillmentTimeModal";
import PreactModal from "../../components/PreactModal";
import RestaurantDeliveryAddressWarning from "../../components/RestaurantDeliveryAddressWarning";
function FulfillmentSettings(props) {
    const { orderDetails, fulfillmentMethodsOptions, fulfillmentMethodController, fulfillmentTimeController, openingHour, } = props;
    // TODO: handle it in the Client (Online / QrWaiter OrderDetails?)
    if (orderDetails.fulfillmentTime.type == "QrWaiter" ||
        orderDetails.fulfillmentMethodAddress === null) {
        return null;
    }
    return (h("div", { class: "u-flex" },
        h(FulfillmentMethodSwitcher, { options: fulfillmentMethodsOptions, controller: fulfillmentMethodController.fields.fulfillmentMethod }),
        h(AddressButton, { isDelivery: orderDetails.isDelivery, address: orderDetails.fulfillmentMethodAddress, controller: fulfillmentMethodController, deliveryAddressStatus: orderDetails.deliveryAddressStatus }),
        h(TimeButton, { fulfillmentTime: orderDetails.fulfillmentTime, controller: fulfillmentTimeController, openingHour: openingHour }),
        orderDetails.isDelivery && (h(RestaurantDeliveryAddressWarning, { status: orderDetails.deliveryAddressStatus, isPostCodeRequired: false }))));
}
const AddressButton = observer((props) => {
    const { isDelivery, address, controller, deliveryAddressStatus } = props;
    const [isAddressModalOpen, setIsAddressModalOpen] = useState(false);
    const [isRestaurantModalOpen, setIsRestaurantModalOpen] = useState(false);
    const handleOpen = () => {
        if (isDelivery) {
            setIsAddressModalOpen(true);
        }
        else {
            setIsRestaurantModalOpen(true);
        }
    };
    return (h("div", null,
        h("button", { type: "button", class: "btn", onClick: handleOpen }, address === null || address === void 0 ? void 0 :
            address.firstLine,
            " ", address === null || address === void 0 ? void 0 :
            address.secondLine),
        h(FulfillmentAddressModal, { isOpen: isAddressModalOpen, controller: controller, deliveryAddressStatus: deliveryAddressStatus, onShown: () => setIsAddressModalOpen(true), onHidden: () => setIsAddressModalOpen(false) }),
        h(RestaurantModal, { isOpen: isRestaurantModalOpen, onShown: () => setIsRestaurantModalOpen(true), onHidden: () => setIsRestaurantModalOpen(false) })));
});
const RestaurantModal = observer((props) => {
    const { isOpen, onShown, onHidden } = props;
    return (h(PreactModal, { id: "restaurant-info", isOpen: isOpen, onShown: onShown, onHidden: onHidden },
        h("div", { class: "modal-header" },
            h("button", { type: "button", "data-bs-dismiss": "modal", class: "close", "aria-label": translate(t.generic.close) },
                h("span", { "aria-hidden": "true", class: "icon-cancel" })),
            h("h4", { class: "modal-title" }, "...")),
        h("div", { class: "modal-body" }, "Restaurant info..."),
        h("div", { class: "modal-footer modal-footer--sticky" },
            h("button", { type: "button", "data-bs-dismiss": "modal", class: "btn btn-primary btn-block" }, translate(t.theme_defaults.creator.back_to_menu)))));
});
const TimeButton = observer((props) => {
    var _a;
    const { fulfillmentTime, controller, openingHour } = props;
    const [isModalOpen, setIsModalOpen] = useState(false);
    return (h("div", null,
        h("button", { type: "button", class: "btn", onClick: () => setIsModalOpen(true) }, (_a = fulfillmentTime.optionValue) !== null && _a !== void 0 ? _a : "Wybierz"),
        h(FulfillmentTimeModal, { isOpen: isModalOpen, fulfillmentTime: fulfillmentTime, controller: controller, openingHour: openingHour, onShown: () => setIsModalOpen(true), onHidden: () => setIsModalOpen(false) })));
});
export default observer(FulfillmentSettings);
